import React, { Fragment, useEffect, useState } from "react";
import Footer from "components/Footer";
import CreationHeader from "./components/CreationHeader";
import CreationFooter from "./components/CreationFooter";
import BubblesBg from "components/BubblesBg";
import useAccount from "hooks/useAccount";
import LogInModal from "components/LogInModal";

import { useSelector } from "react-redux";

import useBookings from "hooks/useBookings";

import useAccounr from "hooks/useAccount";

import { useLocation, useHistory } from "react-router-dom";
import DetailsModal from "pages/Login/components/DetailsModal";

import { AiOutlineInfoCircle } from "react-icons/ai";
import { Helmet } from "react-helmet";

const Base = ({
  children,
  className,
  footerUseDoneBtn,
  footerOnClickedNext,
  footerOnClickedBack,
  footerDisableNext,
  footerUseConfirmBtn,
  title,
  onLoggedIn,
  shouldShowLoginModal,
  footerHideNextBtn,
  footerHideBackBtn,
  footerRemove,
  loginModalOnDidDismiss,
  showDetailsModal,
  detailsModalOnDidDismiss,
  infoBody,
  footerRelative,
  disableNav,
}) => {
  const HEADER_HEIGHT = "100";
  const FOOTER_HEIGHT = "100";
  const CONTENT_HEIGHT = `calc(100vh - ${HEADER_HEIGHT}px - ${FOOTER_HEIGHT}px)`;

  const [showLoginModal, setShowLoginModal] = useState(shouldShowLoginModal);

  const user = useSelector((state) => state.auth.user);

  const { userIsLoggedIn } = useAccount();

  const booking = useSelector((state) => state.booking);

  const location = useLocation();
  const history = useHistory();

  const { getAndSetUser } = useAccount();

  useEffect(() => {
    console.log("Base rendered for", title);
  }, []);

  useEffect(() => {
    const routesThatArentAllowedForConfirmedBookings = [
      "/where",
      "/when",
      "/what",
      "/anything",
      "/budget",
    ];

    if (
      booking.status === "confirmed" &&
      routesThatArentAllowedForConfirmedBookings.includes(location.pathname)
    ) {
      history.push("/confirm");
    }
  }, [booking.status, location.pathname]);

  useEffect(() => {
    setShowLoginModal(shouldShowLoginModal);
  }, [shouldShowLoginModal]);

  return (
    <>
      <Helmet>
        <title>{title?.toLowerCase()}</title>
      </Helmet>
      <Fragment>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
            backgroundImage: 'url("/images/bg-w-bubble.jpg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className={`relative ${className ? className : ""} pb-[75px] md:pb-0`}
        >
          {/* <BubblesBg /> */}
          <CreationHeader
            height={HEADER_HEIGHT}
            onClickedLogin={() => {
              setShowLoginModal(true);
            }}
            onLoggedIn={onLoggedIn}
            disableNav={disableNav}
          />
          <div
            className="flex items-center flex-col relative w-full p-2 md:p-0 pb-[75px] md:pb-0"
            style={{
              // height: CONTENT_HEIGHT,
              // maxHeight: CONTENT_HEIGHT,
              minHeight: CONTENT_HEIGHT,
              overflow: "visible",
            }}
          >
            <div className="p-3 flex items-center justify-center z-30">
              <h1 className={`text-center ${infoBody && "pl-[40px]"}`}>
                {title ? title : "NO TITLE"}
              </h1>
              {infoBody && (
                <div className="mirum-info-box-holder relative">
                  {/* ICONS */}
                  <div
                    style={{
                      color: "var(--orange)",
                      fontSize: "24px",
                      position: "relative",
                      top: "3px",
                    }}
                    className="p-2 cursor-pointer"
                  >
                    <AiOutlineInfoCircle />
                  </div>

                  {/* POPOUT */}
                  <div className="lowercase mirum-info-box-content fixed md:absolute top-[100px] md:top-0 left-0 py-4 px-6 bg-white rounded-lg shadow-lg z-50 w-full w-[95%] left-[2.5%] mx-auto md:w-[300px] transition-all">
                    {infoBody}
                  </div>
                </div>
              )}
            </div>
            {children}
          </div>
          {!footerRemove && (
            <CreationFooter
              height={FOOTER_HEIGHT}
              useDoneBtn={footerUseDoneBtn}
              useConfirmBtn={footerUseConfirmBtn}
              onClickedNext={footerOnClickedNext}
              onClickedBack={footerOnClickedBack}
              disableNext={footerDisableNext}
              hideNextBtn={footerHideNextBtn}
              hideBackBtn={footerHideBackBtn}
              relative={footerRelative}
            />
          )}
        </div>

        <LogInModal
          show={showLoginModal}
          onDidDismiss={loginModalOnDidDismiss}
          onLoggedIn={
            () => {
              console.log("onLoggedIn callback");
            }
            // () => {
            // onLoggedIn(() => {
            //   console.log("onLoggedIn callback");
            //   setShowLoginModal(false);
            // }
            // );
            // () => {
            //   alert("onLoggedIn");
            // }
          }
        />

        <DetailsModal
          show={showDetailsModal}
          onDidDismiss={detailsModalOnDidDismiss}
          email={user?.email}
          onCodeValidated={async () => {
            console.log("onCodeValidated");
            await getAndSetUser();
          }}
          onDetailsSubmitted={async () => {
            console.log("onDetailsSubmitted");
            await getAndSetUser();
          }}
        />
      </Fragment>
    </>
  );
};

export default Base;
